import { api } from "src/shared/setup/API/api";

import moment from "moment";
import { useState } from "react";
import { IHandleGet } from "./useHttpTableBordero";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";

export const useGetSheetBordero = () => {
  const [loading, setLoading] = useState(false);
  const { nameSearch } = useConfigPageContext();

  const handleGetSheetBordero = async (body: IHandleGet) => {
    setLoading(true);
    try {
      const response = await api.post(
        `/bordero-exportExcel`,
        {
          ...body,
          orderByParcelas: body.orderTable,

          page: 1,
          limit: 100000,
          filter: nameSearch,
        },
        {
          responseType: "blob", // importante para arquivos binários
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // tenta extrair o nome do arquivo do header
      const contentDisposition = response.headers["content-disposition"];
      let fileName = `Parcelas - ${moment().format("DD/MM/YYYY HH:mm")}.xlsx`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // libera o objeto blob da memória
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao baixar o Excel", error);
    } finally {
      setLoading(false);
    }
  };

  return { handleGetSheetBordero, loading };
};
